import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_93: FaireProductEntity = {
  token: "legacy_prod_abbott-93",
  type: "product",
  name: "Small Velvet Pouch with 3D Bee, Black 4×6 L",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/5e4771d1310971299ad0adb6aa3e085adfaf36c37cdd1c2beaaa2fa4400f577b.jpeg",
  priceDollars: 10,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_womens-accessories"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
